import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface HeaderProps {
  onGetQuote: () => void;
}

export default function Header({ onGetQuote }: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    window.open('https://wa.me/919711165605?text=Hi, I need a bulk quote for printer consumables', '_blank');
  };

  return (
    <>
      {/* Top Info Bar - Infinite Scrolling Strip */}
      <div className="bg-teal-800 text-white py-2 overflow-hidden relative w-full">
        <div className="animate-scroll-left whitespace-nowrap inline-block">
          <div className="inline-flex items-center gap-8 px-4">
            <div className="flex items-center gap-2">
              <i className="ri-truck-line text-lg"></i>
              <span className="font-medium">B2B Supply Across India</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-lg"></i>
              <span className="font-medium">Same-Day Quote Response</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-whatsapp-line text-lg"></i>
              <span className="font-medium">WhatsApp: +91-97111-65605</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-box-3-line text-lg"></i>
              <span className="font-medium">Wide Product Categories Available</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-secure-payment-line text-lg"></i>
              <span className="font-medium">GST: 07AAWFG3117C1ZI</span>
            </div>
            {/* Duplicate for seamless loop */}
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-truck-line text-lg"></i>
              <span className="font-medium">B2B Supply Across India</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-lg"></i>
              <span className="font-medium">Same-Day Quote Response</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-whatsapp-line text-lg"></i>
              <span className="font-medium">WhatsApp: +91-97111-65605</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-box-3-line text-lg"></i>
              <span className="font-medium">Wide Product Categories Available</span>
            </div>
            <span className="text-teal-300">•</span>
            <div className="flex items-center gap-2">
              <i className="ri-secure-payment-line text-lg"></i>
              <span className="font-medium">GST: 07AAWFG3117C1ZI</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`sticky top-0 z-50 transition-all duration-300 w-full ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="container mx-auto px-6 lg:px-12 w-full max-w-full">
          <div className="flex items-center justify-between h-20 w-full lg:grid lg:grid-cols-3">
            {/* Logo - Left Aligned */}
            <Link to="/" className="flex items-center gap-3 cursor-pointer flex-shrink-0 lg:justify-start">
              <img
                src="https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/400664175eef7daba939234b6dd4e0a2.png"
                alt="GI2 Logo"
                className="h-12 lg:h-14 w-auto"
              />
              <span className="hidden lg:block text-gray-900 font-bold text-xl whitespace-nowrap">Gi2 Merchants LLP</span>
            </Link>

            {/* Company Name - Center on Mobile, Desktop Navigation on Desktop */}
            <div className="flex items-center justify-center lg:hidden">
              <Link to="/" className="cursor-pointer">
                <span className="text-gray-900 font-bold text-lg leading-tight">Gi2 Merchants LLP</span>
              </Link>
            </div>

            {/* Desktop Navigation - Center */}
            <nav className="hidden lg:flex items-center justify-center gap-6 xl:gap-8">
              <Link
                to="/"
                className="text-gray-700 hover:text-teal-700 font-medium transition-colors duration-200 relative group cursor-pointer whitespace-nowrap"
              >
                Home
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-teal-700 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link
                to="/products"
                className="text-gray-700 hover:text-teal-700 font-medium transition-colors duration-200 relative group cursor-pointer whitespace-nowrap"
              >
                Products
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-teal-700 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link
                to="/become-a-dealer"
                className="text-gray-700 hover:text-teal-700 font-medium transition-colors duration-200 relative group cursor-pointer whitespace-nowrap"
              >
                Become a Dealer
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-teal-700 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link
                to="/about"
                className="text-gray-700 hover:text-teal-700 font-medium transition-colors duration-200 relative group cursor-pointer whitespace-nowrap"
              >
                About
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-teal-700 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link
                to="/contact"
                className="text-gray-700 hover:text-teal-700 font-medium transition-colors duration-200 relative group cursor-pointer whitespace-nowrap"
              >
                Contact
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-teal-700 group-hover:w-full transition-all duration-300"></span>
              </Link>
            </nav>

            {/* Right CTAs */}
            <div className="flex items-center gap-4 flex-shrink-0 lg:justify-end">
              <button
                onClick={onGetQuote}
                className="hidden md:flex items-center gap-2 px-6 py-2.5 bg-teal-700 hover:bg-teal-800 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Get Quote
              </button>
              <button
                onClick={handleWhatsApp}
                className="hidden lg:flex w-10 h-10 items-center justify-center rounded-full bg-orange-500 hover:bg-orange-600 text-white transition-all duration-300 cursor-pointer flex-shrink-0"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </button>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer flex-shrink-0"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg w-full">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4 w-full">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 hover:text-teal-700 font-medium py-2 cursor-pointer"
              >
                Home
              </Link>
              <Link
                to="/products"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 hover:text-teal-700 font-medium py-2 cursor-pointer"
              >
                Products
              </Link>
              <Link
                to="/become-a-dealer"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 hover:text-teal-700 font-medium py-2 cursor-pointer"
              >
                Become a Dealer
              </Link>
              <Link
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 hover:text-teal-700 font-medium py-2 cursor-pointer"
              >
                About
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 hover:text-teal-700 font-medium py-2 cursor-pointer"
              >
                Contact
              </Link>
              <button
                onClick={() => {
                  onGetQuote();
                  setIsMobileMenuOpen(false);
                }}
                className="w-full px-6 py-3 bg-teal-700 hover:bg-teal-800 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Get Quote
              </button>
            </nav>
          </div>
        )}
      </header>
    </>
  );
}
